<template>
  <div v-if="!isSubscriber" :class="color" class="helpful-hint notification is-light">
    <template v-if="!loggedIn">
      <div class="flex">
        <img src="/group-video.png">
        <p>{{ getRandom(registerCTAs) }}</p>
      </div>
      <n-link :class="color" @click="trackEvent('Helpful Hint Register')" to="/register" class="button is-medium">Get Started Free</n-link>
    </template>

    <template v-else-if="!isPassActive">
      <div class="flex">
        <img src="/group-video.png">
        <p>{{ getRandom(upgradeCTAs) }}</p>
      </div>
      <div @click="startUpgrade(); trackEvent('Helpful Hint Upgrade')" :class="color" class="button is-medium">Upgrade to Pro</div>
    </template>

    <template v-else-if="isPassActive">
      <div class="flex">
        <img src="/group-video.png">
        <p>{{ getRandom(extendCTAs) }}</p>
      </div>
      <div @click="startUpgrade(); trackEvent('Helpful Hint Extend')" :class="color" class="button is-medium">Upgrade to annual</div>
    </template>
  </div>
</template>

<script>
import shuffle from 'lodash.shuffle'
import ExtendPass from '~/components/modals/ExtendPass'
import UpgradeAccount from '~/components/modals/UpgradeAccount'

export default {
  props: {
    color: {
      type: String,
      default: 'is-secondary'
    }
  },
  data () {
    return {
      registerCTAs: [
        `Run your own interactive word clouds, live polls, photo sharing sessions, and more — it's easy!`,
        'Use our interactive slides to brainstorm, run team building games, play classroom review games, and more',
        'Create an account to use any of our ready-to-play decks, or to make your own from scratch!'
      ],
      upgradeCTAs: [
        'Have a big group? You can host up to 250 people when you upgrade to a Pro account',
        'Tired of the usual event join codes? With a premium account you can customize them to perfectly for your group.',
        'You can add your own branding (and remove ours) with any of our paid accounts. Give it a shot!',
        'Pro accounts allow you to export all of your event data as a CSV. Review scores, save responses, or integrate your event data with other sources. Try it out!'
      ],
      extendCTAs: [
        `Get the cost of your pass back: upgrade for the year and we'llsubtract price of your pass (and you get this month free)`,
        `Want unlimited events for the year? Upgrade to an annual subscription and we'll apply the full value of your pass as a discount`,
        `Get this month for free. When you upgrade to an annual pass we'll credit you full cost you paid for your event pass`
      ]
    }
  },
  computed: {
    loggedIn () {
      return this.$auth.loggedIn
    },
    isSubscriber () {
      return this.$store.getters.isSubscriber
    },
    isPassActive () {
      return this.$store.getters.isPassActive
    }
  },
  methods: {
    getRandom (arr) {
      if (typeof arr === 'string') { return arr }
      if (!Array.isArray(arr)) { return }
      return shuffle(arr)[0]
    },
    startUpgrade () {
      if (this.$route.hash !== '#upgrade') {
        this.log('router not showing upgrade hash, adding it')
        this.$router.replace({ hash: 'upgrade' })
        this.trackEvent('Start Upgrade Navbar')
      }

      this.$buefy.modal.open({
        parent: this,
        fullScreen: true,
        component: this.isPassActive ? ExtendPass : UpgradeAccount,
        customClass: 'upgrade-modal',
        canCancel: false,
        trapFocus: true,
        onCancel: () => {
          this.$router.replace({ hash: '' })
        }
      })
    }
  }
}
</script>
